import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { EMobilityConnectionState } from './types';

export const getters: GetterTree<EMobilityConnectionState, RootState> = {}
